// extracted by mini-css-extract-plugin
module.exports = {"realStory":"C_realStory__JGPng","imgScale":"C_imgScale__UvMoU","imgScale2":"C_imgScale2__6d6kw"};